import React from 'react';
import cx from 'classnames';
import Image from 'next/image';
import Button from '@separate/components/Button';
import { useTranslation } from '@separate/hooks/translation';
import { csLoader } from '@separate/utilities/image';
import styles from './askUsAnything.module.scss';

export default function AskUsAnything() {
  const { t } = useTranslation();

  const onClick = () => {
    window.location.href = 'tel: 877-210-2513';
  };

  return (
    <div className={styles.AskUsAnything}>
      <div>
        <p>{t('premium.ask_us_anything.title')}</p>
      </div>
      <div>
        <Image
          src={require('@separate/res/askUsAnything.png')}
          alt='Ask us anything image'
          loader={csLoader}
          height='64'
          width='64'
        />
      </div>
      <div className={cx(styles.questionContainer, styles.arrowTop)}>
        <p>{t('premium.ask_us_anything.got_questions')}</p>
        <div className={styles.button}>
          <Button onClick={onClick}>{t('premium.ask_us_anything.talk_with_an_expert')}</Button>
        </div>
      </div>
    </div>
  );
}
